import React from 'react';
import { guid } from './guid';
import { ModalHeaderSubtitle, ModalHeaderTitle } from '../components/texts/ModalHeaderStyles';
import ImageWithLabel from '../components/layouts/ImageWithLabel';
import ModalHeaderDescription from '../components/modals/generic-modal/header/ModalHeaderDescription';

const getComponentsByKey = {
    description: ModalHeaderDescription,
    subtitle: ModalHeaderSubtitle,
    tags: ImageWithLabel,
    title: ModalHeaderTitle,
};

const renderDefaultComponentByProperty = ({ property, value }) => {
    const isCustomComponent = typeof value === 'function';
    const Component = getComponentsByKey[property];

    if (isCustomComponent) return value();
    if (Array.isArray(value)) return value.map(props => <Component key={guid()} {...props} />);
    if (typeof value === 'object') return <Component {...value} />;
    return <Component>{value}</Component>;
};

export default renderDefaultComponentByProperty;
